<template>
  <div class="download how-to-getcode">
    <div
      :class="{
        'white-wrap': true,
        'white-wrap2': isShowAbout >= 1 && isShowAbout <= 6,
        'white-wrap3': isShowAbout == 7,
        'white-wrap4': isShowAbout == 8,
        'white-wrap5': isShowAbout == 10,
      }"
    >
      <div class="how-close" @click="closeAboutAlert"></div>
      <div
        :class="{
          title1: isShowAbout >= 1 && isShowAbout <= 6,
          'title-client': isShowAbout == 7,
          'title-client2': isShowAbout == 8,
          'title-client3': isShowAbout == 10,
        }"
      ></div>
      <div class="title2"></div>
      <div class="client-part" v-if="isShowAbout == 7">
        <!-- <div class="client-part-title">高速传输 超级好用</div> -->
        <div class="client-item-wrap">
          <div class="client-item client-item1">
            <div class="item-icon"></div>
            <div class="item-text">远程音频</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon2"></div>
            <div class="item-text">远程文件</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon3"></div>
            <div class="item-text">远程管理</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon4"></div>
            <div class="item-text">发起唤醒</div>
          </div>
        </div>
        <div class="client-item-wrap client-item-wrap2">
          <div class="client-item client-item1">
            <div class="item-icon item-icon5"></div>
            <div class="item-text">远程视频</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon6"></div>
            <div class="item-text">远程照片</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon7"></div>
            <div class="item-text">相册备份</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon8"></div>
            <div class="item-text">端口映射</div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="client-part" v-if="isShowAbout == 8">
        <!-- <div class="client-part-title">不仅被控 还有大用</div> -->
        <div class="client-item-wrap">
          <div class="client-item client-item2">
            <div class="item-icon item-icon3"></div>
            <div class="item-text">远程桌面</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon4"></div>
            <div class="item-text">发起唤醒</div>
          </div>
        </div>
        <div class="client-item-wrap client-item-wrap2">
          <div class="client-item client-item2">
            <div class="item-icon item-icon7"></div>
            <div class="item-text">相册备份</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon8"></div>
            <div class="item-text">端口映射</div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="client-part" v-if="isShowAbout == 10">
        <!-- <div class="client-part-title">不仅被控 还有大用</div> -->
        <div class="client-item-wrap">
          <div class="client-item client-item2">
            <div class="item-icon item-icon3"></div>
            <div class="item-text">远程桌面</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon4"></div>
            <div class="item-text">发起唤醒</div>
          </div>
        </div>
        <div class="client-item-wrap client-item-wrap2">
          <div class="client-item client-item2">
            <div class="item-icon item-icon7"></div>
            <div class="item-text">相册备份</div>
          </div>
          <div class="client-item">
            <div class="item-icon item-icon8"></div>
            <div class="item-text">端口映射</div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="pc-part" v-if="isShowAbout >= 1 && isShowAbout <= 6">
        <div class="left-part">
          <div class="item">
            <div class="item-icon-wrap">
              <div
                :class="{
                  'item-icon': true,
                  'icon-nas-dark':
                    isShowAbout == 4 || isShowAbout == 5 || isShowAbout == 6,
                }"
              ></div>
            </div>
            <div
              :class="{
                'item-text': true,
                'text-dark':
                  isShowAbout == 4 || isShowAbout == 5 || isShowAbout == 6,
              }"
            >
              远程访问NAS
            </div>
            <div
              class="item-text2"
              v-if="isShowAbout == 4 || isShowAbout == 5 || isShowAbout == 6"
            >
              暂不支持
            </div>
            <div class="item-icon2" v-else></div>
          </div>
          <div class="item">
            <div class="item-icon-wrap">
              <div
                :class="{
                  'icon-dark': true,
                  'icon-remote': isShowAbout == 2 || isShowAbout == 3,
                }"
              ></div>
            </div>
            <div
              :class="{
                'item-text': true,
                'text-dark':
                  isShowAbout == 1 ||
                  isShowAbout == 4 ||
                  isShowAbout == 5 ||
                  isShowAbout == 6,
              }"
            >
              远程桌面
            </div>
            <div
              class="item-text2"
              v-if="
                isShowAbout == 1 ||
                isShowAbout == 4 ||
                isShowAbout == 5 ||
                isShowAbout == 6
              "
            >
              暂不支持
            </div>
            <div class="item-icon2" v-else></div>
          </div>
          <div class="item">
            <div class="item-icon-wrap">
              <div class="icon-dark icon-open"></div>
            </div>
            <div class="item-text">远程开机</div>
            <div class="item-icon2"></div>
          </div>
        </div>
        <div class="left-part right-part">
          <div class="item">
            <div class="item-icon-wrap">
              <div class="icon-dark icon-dark2"></div>
            </div>
            <div class="item-text">远程路由管理</div>
            <div class="item-icon2"></div>
          </div>
          <div class="item">
            <div class="item-icon-wrap">
              <div class="icon-dark icon-dark3"></div>
            </div>
            <div class="item-text">小工具</div>
            <div class="item-icon2"></div>
          </div>
          <div class="item">
            <div class="item-icon-wrap">
              <div class="icon-dark icon-dark4"></div>
            </div>
            <div class="item-text">高级服务</div>
            <div class="item-icon2"></div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="use">
        <div class="use-title"></div>
        <div class="use-item-wrap">
          <div class="use-item">
            <div class="item-text">NO.1</div>
            <div class="item-content">
              <div class="content-text1">安装设备端</div>
              <div class="content-text1">获取绑定码</div>
            </div>
          </div>
          <div class="use-item">
            <div class="item-text">NO.2</div>
            <div class="item-content">
              <div class="content-text1">启动客户端</div>
              <div class="content-text1">输入绑定码</div>
            </div>
          </div>
          <div class="use-item use-item2">
            <div class="item-text">NO.3</div>
            <div class="item-content item-content2">
              <div class="content-text1">使用客户端</div>
              <div class="content-text1">访问服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
  props: ["isShowAbout"],
  methods: {
    closeAboutAlert: function () {
      let _that = this;
      _that.$emit("closeAboutAlert");
    },
  },
};
</script>

<style lang="less" scoped>
.how-to-getcode {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9;
  .white-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: 391px;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .how-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
      background-image: url("../../assets/remote/close1.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .title1 {
      display: inline-block;
      margin-top: 32px;
      margin-left: 35px;
      vertical-align: top;
      width: 123px;
      height: 34px;
      background-image: url("../../assets/remote/about8.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .title-client {
      display: inline-block;
      margin-top: 32px;
      margin-left: 35px;
      margin-right: 10px;
      vertical-align: top;
      width: 98px;
      height: 34px;
      background-image: url("../../assets/remote/about24.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .title-client2 {
      display: inline-block;
      margin-top: 32px;
      margin-left: 35px;
      margin-right: 10px;
      vertical-align: top;
      width: 152px;
      height: 34px;
      background-image: url("../../assets/remote/about33.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .title-client3 {
      display: inline-block;
      margin-top: 32px;
      margin-left: 35px;
      margin-right: 10px;
      vertical-align: top;
      width: 97px;
      height: 34px;
      background-image: url("../../assets/remote/about42.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .title2 {
      display: inline-block;
      margin-top: 35px;
      margin-left: 18px;
      vertical-align: top;
      width: 113px;
      height: 28px;
      background-image: url("../../assets/remote/about9.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .pc-part {
      margin-top: 18px;
      .left-part {
        display: inline-block;
        vertical-align: top;
        width: 306px;
        border-right: 1px solid rgba(20, 57, 119, 0.1);
        .item {
          height: 56px;
          padding-top: 1px;
          box-sizing: border-box;
          .item-icon-wrap,
          .item-text,
          .item-icon2,
          .item-text2 {
            display: inline-block;
            vertical-align: top;
          }
          .item-icon-wrap {
            margin-left: 18px;
            width: 63px;

            .item-icon {
              margin: 0 auto;
              margin-top: 12px;
              width: 32px;
              height: 32px;
              background-image: url("../../assets/remote/about23.svg");
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
            .icon-dark {
              margin: 0 auto;
              margin-top: 12px;
              width: 32px;
              height: 32px;
              background-image: url("../../assets/remote/about20.svg");
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center;
            }
            .icon-open {
              background-image: url("../../assets/remote/about13.svg");
            }
            .icon-remote {
              background-image: url("../../assets/remote/about21.svg");
            }
            .icon-nas-dark {
              background-image: url("../../assets/remote/about22.svg");
            }
          }
          .item-text {
            width: 136px;
            line-height: 56px;
            font-weight: 600;
            font-size: 16px;
            color: #666666;
          }
          .item-icon2 {
            margin-top: 20px;
            width: 48px;
            height: 16px;
            background-image: url("../../assets/remote/about11.svg");
            background-repeat: no-repeat;
            background-size: 16px 16px;
            background-position: center;
          }

          .text-dark {
            color: #999999;
          }
          .item-text2 {
            color: #8e9092;
            font-size: 12px;
            line-height: 56px;
          }
        }
      }
      .right-part {
        width: 290px;
        border-right: none;
        .item {
          .item-icon-wrap {
            margin-left: 11px;
            .icon-dark2 {
              background-image: url("../../assets/remote/about14.svg");
            }
            .icon-dark3 {
              background-image: url("../../assets/remote/about15.svg");
            }
            .icon-dark4 {
              background-image: url("../../assets/remote/about16.svg");
            }
          }
        }
      }
      .line {
        margin-left: 32px;
        margin-top: 8px;
        height: 1px;
        width: 548px;
        background-color: rgba(20, 57, 119, 0.1);
      }
    }
    .client-part {
      margin-top: 14px;
      .client-part-title {
        margin-left: 36px;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
      }
      .client-item-wrap {
        margin-top: 14px;
        .client-item {
          display: inline-block;
          vertical-align: top;
          .item-icon {
            display: inline-block;
            margin-left: 22px;
            vertical-align: top;
            width: 48px;
            height: 48px;
            background-image: url("../../assets/remote/about25.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            box-shadow: 0px 3px 6px rgba(150, 170, 220, 0.25);
            border-radius: 50%;
          }
          .item-icon2 {
            background-image: url("../../assets/remote/about26.svg");
          }
          .item-icon3 {
            background-image: url("../../assets/remote/about27.svg");
          }
          .item-icon4 {
            background-image: url("../../assets/remote/about28.svg");
          }
          .item-icon5 {
            background-image: url("../../assets/remote/about29.svg");
          }
          .item-icon6 {
            background-image: url("../../assets/remote/about30.svg");
          }
          .item-icon7 {
            background-image: url("../../assets/remote/about31.svg");
          }
          .item-icon8 {
            background-image: url("../../assets/remote/about32.svg");
          }
          .item-text {
            display: inline-block;
            margin-left: 13px;
            vertical-align: top;
            line-height: 48px;
            font-size: 14px;
            color: #666666;
          }
        }
        .client-item1 {
          margin-left: 14px;
        }
        .client-item2 {
          margin-left: 170px;
        }
      }
      .client-item-wrap2 {
        margin-top: 22px;
      }
      .line {
        margin-left: 32px;
        margin-top: 23px;
        height: 1px;
        width: 548px;
        background-color: rgba(20, 57, 119, 0.1);
      }
    }
    .client-part2 {
      margin-top: 14px;
      .client-part2-title {
        margin-left: 36px;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
      }
    }
    .use {
      margin-top: 10px;
      .use-title {
        margin-left: 32px;
        width: 56px;
        height: 20px;
        background-image: url("../../assets/remote/about17.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .use-item-wrap {
        text-align: center;
        .use-item {
          display: inline-block;
          margin-right: 18px;
          vertical-align: top;
          .item-text {
            margin-left: 5px;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            color: #143977;
          }
          .item-content {
            position: relative;
            margin-top: 3px;
            padding-top: 9px;
            width: 171px;
            height: 58px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            box-sizing: border-box;
            text-align: left;
            .content-text1 {
              margin-left: 15px;
              font-size: 14px;
              line-height: 20px;
              color: #666666;
            }
          }
          .item-content::after {
            content: "";
            position: absolute;
            right: 26px;
            top: 17px;
            width: 22px;
            height: 23px;
            background-image: url("../../assets/remote/about18.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item-content2::after {
            background-image: url("../../assets/remote/about19.svg");
          }
        }
        .use-item2 {
          margin-right: 0;
        }
      }
    }
  }
  .white-wrap2 {
    background-image: url("../../assets/remote/about38.png");
  }
  .white-wrap3 {
    background-image: url("../../assets/remote/about39.png");
  }
  .white-wrap4 {
    background-image: url("../../assets/remote/about40.png");
  }
  .white-wrap5 {
    background-image: url("../../assets/remote/about41.png");
  }
}
</style>